import { render } from "./DeliveryIcon.vue?vue&type=template&id=a97274e2&scoped=true"
import script from "./DeliveryIcon.vue?vue&type=script&lang=js"
export * from "./DeliveryIcon.vue?vue&type=script&lang=js"

import "./DeliveryIcon.vue?vue&type=style&index=0&id=a97274e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a97274e2"]])

export default __exports__